<!--xgplayer  -->
<template>
    <div class="cam" style="background-color: #000;text-align: center">
        <div class="video" v-show="isPlay" ref="camDOMidRef" :id="camDOMid"></div>
    </div>
</template>

<script>
    import FlvJsPlayer from 'xgplayer-flv';
    import Player from 'xgplayer';
    export default {
        name: "xgPlayer",
        components: {},
        props: {
            camDOMid: {type: String},
            width: {type: String},
            height: {type: String},
            videoUrl:{type: String},
            controls:{
                type: Boolean,
                default:true
            },
            limitReloadCount:{
                type: Number,
                default:10,
            },
            poster:{
                type:String,
                default:require('@/assets/img/bigScreen/defaultVideoBg.png')
            },
            videoCode: {
                type: String,
                default: "mp4", //只支持mp4或MP4
                validator: function (value) {
                    // 这个值必须匹配下列字符串中的一个
                    return ["flv", "MP4"].indexOf(value) !== -1;
                },
            },
            voice:{
                type: Boolean,
                default:true,
            },
            id:{
                type: String,
                default:'1'
            },
            serverUrl:{
                type: String,
                default:''
            },
        },
        data() {
            return {
                isPlay: false, //是否显示播放画面
                player: null, //播放实例
                lastDecodedFrame: 0, //最后一个decodedFrame
                sameCount: 0, //decodedFrame不变次数
                currentTime: 0, //当前时间
                lastCurrentTime: 0, //最后的时间
                timer: "", //定时器
            }
        },
        computed: {

        },
        watch: {
            //监听videoUrl变化，改变播放地址
            videoUrl: {
                handler(newval) {
                    this.player.src = this.playUrl(newval)
                }
            }
        },
        created() {
            //10秒定时任务判断画面时间是否没变化，没变化就重连
            let _this = this;
            _this.timer = setInterval(() => {
                if (_this.lastCurrentTime == _this.currentTime) {
                    console.log("10秒定时任务判断画面时间没变化，销毁重连",new Date());
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    // if (_this.player) { //如果有实例，就销毁
                    //     _this.player.destroy(); //销毁 
                    // }
                    // _this.getData() //重连
                    _this.player.reload();
                } else {
                    _this.currentTime = _this.player.currentTime
                }
            }, 10 * 1000);
        },

        mounted() {
            //获取数据，连接
            this.getData(this.videoUrl);
            //检测网络连接，销毁重连
            let _this = this;
            window.addEventListener("online", () => {
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            });
            //12小时后，销毁重连
            setTimeout(() => {
                console.log("12小时后，销毁重连");
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            }, 12 * 60 * 60 * 1000);
        },
        methods: {
            // 视频截图及上传文件服务器
            cutVideoScreen(){

                var fileType = "png";  // 如果文件名中没有带后缀，默认使用png
                var video = document.getElementById(this.camDOMid).getElementsByTagName("video")[0];  // 找到需要截图的video标签
                if(video){
                    var canvas = window.canvas = document.createElement("canvas");
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);  // 图片大小和视频分辨率一致
                    var strDataURL = canvas.toDataURL("image/" + fileType);   // canvas中video中取一帧图片并转成dataURL
                    var arr = strDataURL.split(','),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    var blob = new Blob([u8arr], {
                        type: mime
                    });

                    const formData = new FormData();
                    formData.append('file', blob);

                    if(blob){

                        this.$http.post('/bigfileUpload/uploadFile',formData ).then(res => {


                            if(res.data.code == "1"){
                                var filePath = res.data.data;
                                this.$emit('cutAndUploadSuccess', filePath);

                            }else{
                                this.$message({message: "上传失败", type: "error"});
                            }

                        }).catch(e => {

                        })

                    }
                }

            },
            // 设置视频配置(注意：initPlayer应放在异步函数里或mounted之后，不可在created里直接加载，否则不生效)
            initPlayer(url) {
                this.isPlay = true;
                this.$nextTick(function () {
                    let _this = this;
                    this.player = new FlvJsPlayer({
                        id: this.camDOMid,
                        url: url,
                        hasStart: true,
                        autoplay: true, //自动播放，设置自动播放必要参数
                        autoplayMuted: true, //自动播放静音，设置自动播放参数必要参数
                        volume: 0,
                        poster:this.poster,
                        height:this.height,
                        width: this.width,
                        errorTips: `视频播放失败，请刷新页面重试。`,
                        defaultMuted: true,
                        isLive: true,
                        playsinline: false,
                        screenShot: false,
                        fluid: true,
                        aspectRatio: '16:9',
                        whitelist: [''],
                        ignores: ['time'],
                        closeVideoClick: false,
                        // errorTips: '<span class="app-error">无视频源</span>',
                        customConfig: {
                            isClickPlayBack: false
                        },
                        flvOptionalConfig: {
                            enableWorker: true,
                            enableStashBuffer: false, //启用缓存
                            stashInitialSize: 4096, //缓存大小4m
                            lazyLoad: false,
                            lazyLoadMaxDuration: 40 * 60,
                            autoCleanupSourceBuffer: true, //自动清除缓存
                            autoCleanupMaxBackwardDuration: 35 * 60,
                            autoCleanupMinBackwardDuration: 30 * 60,
                            reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                        } //flv.js可选配置项 [flv.js配置](https://github.com/bilibili/flv.js/blob/master/docs/api.md#config)
                    });
                    this.player.once('canplay', () => {})
                    this.player.once('error', () => {
                        if (this.player) {
                            this.player.replay();
                        }
                        return;
                    })
                    this.player.once('pause', () => {
                        // console.log('pause')
                    })
                    this.player.once('canplaythrough', () => {
                        console.log('可流畅播放')
                    })

                    //检测画面是否卡死。如果decodedFrames不再发生变化,就销毁掉该实例并进行重新连接。这个函数基本是1秒执行一次的。
                    this.player.on("statistics_info", function (res) {
                        if (_this.lastDecodedFrame == 0) {
                            _this.lastDecodedFrame = res.decodedFrames;
                            return;
                        }
                        if (_this.lastDecodedFrame != res.decodedFrames) {
                            _this.lastDecodedFrame = res.decodedFrames;
                            _this.lastCurrentTime = _this.player.currentTime; //最后的时间
                            _this.sameCount = 0;
                        } else {
                            _this.sameCount++;
                            console.log("decodedFrames没有发生变化第", _this.sameCount, "次。时间：", new Date());

                            if (_this.sameCount > 9) {
                                //decodedFrames10次不变，则判断为画面卡死，销毁实例进行重连
                                console.log("画面卡死，进行重连————————", "时间", new Date());
                                _this.lastDecodedFrame = 0;
                                _this.sameCount = 0;

                                if (_this.player) {
                                    _this.currentTime = 0;
                                    _this.lastCurrentTime = 0;
                                    _this.player.destroy(); //销毁 
                                    _this.getData() //重连
                                }
                            }
                        }
                        // console.log("最后的时间：", _this.lastCurrentTime, "   10秒前的时间：",_this.currentTime);
                    });
                    // //优化延迟
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     console.log("缓冲区末尾",this.player.getBufferedRange()[1],"当前位置：",this.player.currentTime);
                    //     if(this.player.getBufferedRange()[1]){
                    //       let end = this.player.getBufferedRange()[1];
                    //       let diff = end - this.player.currentTime;//获取buffered与currentTime的差值
                    //       if (diff >= 1) {//如果差值大于等于3 手动跳帧 这里可根据自身需求来定
                    //         this.player.currentTime = this.player.getBufferedRange()[1];//手动跳帧
                    //         console.log("优化延迟，手动跳帧，时间：",new Date());
                    //       }
                    //     }
                    //   }, 2000); //2000毫秒执行一次  
                    // }, 3000);

                })
            },
            //获取数据，连接
            getData() {
                let playUrl = this.playUrl(this.videoUrl)
                this.initPlayer(playUrl)
            },
            //拼接地址
            playUrl(val) {
                // var webSocketUrl = config.webSocket; //webSocket的ip
                // let playUrl = "ws://" + webSocketUrl + "/live?url=" + val; //播放地址
                return val;
            },
            play(){ //播放
                if(this.player){
                    this.player.play();
                }
            },
            pause(){ // 暂停
                if(this.player){
                    this.player.pause();
                }
            },

        },
        beforeDestroy() {
            clearInterval(this.timer)
            if (this.player) {
                this.player.destroy();
            }
            //销毁监听
            let _this = this;
            window.removeEventListener('online', () => {
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            }, true);
        },

    }

</script>
<style lang="less" scoped>
</style>
<style lang="less">
    .video {
        width: 100%;
        height: 100%;
    }

</style>

